const sanitizePathSegment = (value) => {
  if (!value) return "";
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/[\s_]+/g, "-")
    .replace(/-+/g, "-");
};

export const buildTermsAndConditionsLink = ({ templateName, apPid, drugName }) => {
  if (!templateName || !apPid || !drugName) return "";
  return `https://public-assets.tailormed.co/express_enroll/${sanitizePathSegment(templateName)}/${sanitizePathSegment(
    apPid
  )}/${sanitizePathSegment(drugName)}/terms-and-conditions.pdf`;
};
